<template>
    <div class="pl-1 pb-1">
        <p class="text-muted mb-1">{{ __('Only enquiries belonging to a country with an associated user will be allocated.') }}</p>
        <button class="btn btn-success" @click="autoAllocate" :disabled="disabled">{{ __('Auto Allocate') }}</button>
    </div>
</template>

<script>
export default {
    name: "AutoAllocateButton",

    data() {
        return {
            disabled: false
        };
    },

    methods: {
        autoAllocate(e) {
            this.disabled = true;

            axios
                .post("/api/enquiries/allocate/auto")
                .then(response => {
                    console.log(response);

                    let data = response.data;
                    if (!data.success) {
                        this.disabled = false;

                        $("#fail-alert")
                            .text(data.message || "Unknown error")
                            .slideDown(500)
                            .delay(5000)
                            .slideUp(500);
                    } else {
                        location.reload();
                    }
                })
                .catch(error => {
                    console.log(error.response);
                    this.disabled = false;

                    $("#fail-alert")
                        .text(error || "Unknown error")
                        .slideDown(500)
                        .delay(5000)
                        .slideUp(500);
                });
        }
    }
};
</script>
